jQuery(document).ready(function ($) {
  if ($('.popup').length) {
    // Check and set popup cookies
    $('.popup:not(.popup--changelog)').each(function(index, el) {
      var match = $(this).attr('data-match')
      var expiresDays = parseInt($(this).attr('data-popupexpires'))

      if(!Cookies.get(match)){
        Cookies.set(match, {show: true}, {expires: expiresDays})
      }

      // If popup exists and it's not meant to show on scroll
      if(Cookies.getJSON(match).show && !$(this).hasClass('popup--scroll')) {
        $(this).addClass('active')
        $(this).siblings('.popupOverlay').addClass('active')
      }
    });

    $('.popupOverlay:not(.popupOverlay--changelog)').click(function(e) {
      e.preventDefault()
      e.stopPropagation()

      $('body').removeClass('u-noScroll')
      $(this).removeClass('active');
      $(this).siblings('.popup, .popupOverlay').removeClass('active');

      if ($(this).hasClass('popupOverlay')) {
        var match = $(this).attr('data-match')
        var expiresDays = parseInt($(this).attr('data-popupexpires'))

        Cookies.set(match, {show:false}, {expires: expiresDays})
      }
    });

    $('.popup-close:not(.popup-close--changelog)').click(function(e) {
      e.preventDefault()
      e.stopPropagation()

      $('body').removeClass('u-noScroll')
      $(this).parent().parent().removeClass('active');
      $(this).parent().parent().siblings('.popupOverlay').removeClass('active');

      if ($(this).parent().parent().hasClass('popup')) {
        var match = $(this).parent().parent().attr('data-match')
        var expiresDays = parseInt($(this).attr('data-popupexpires'))

        Cookies.set(match, {show:false}, {expires: expiresDays})
      }
    });

    $(window).scroll(function() {
      if ($('.popup--scroll').length) {
        $('.popup--scroll, .popupOverlay').each(function(index, el) {
          var scrolledPercent = $(this).attr('data-scroll') / 100
          var match = $(this).attr('data-match')
          var expiresDays = parseInt($(this).attr('data-popupexpires'))

          var actualHeight = $(document).height() - $(window).height()

          if(Cookies.getJSON(match).show && $(window).scrollTop() > actualHeight * scrolledPercent) {
            $(this).addClass('active')
          }
        });
      }
    });
  }
})
